// Recommendation values match the prepared-engine response.recommendation.key contract.
// Keep the legacy values unchanged for existing device menus.
export const RecommendationTypeOptions = [
    {value: 'continue-watching', label: 'Continue Watching (Recommendations)', contentType: 'SVOD'},
    {value: 'popular', label: 'Popular Movies (TMDB)', contentType: 'SVOD'},
    ...[1, 2, 3, 4, 5].map(slot => ({
        value: `because-movie-${slot}`,
        label: `Because You Watched Movies ${slot}`,
        contentType: 'SVOD'
    })),
    ...[1, 2, 3, 4, 5].map(slot => ({
        value: `because-series-${slot}`,
        label: `Because You Watched TV ${slot}`,
        contentType: 'SERIES'
    })),
    {value: 'recommended-for-you', label: 'Recommended for You (TMDB)', contentType: 'SVOD'},
    {value: 'top-rated', label: 'Top Rated Movies (TMDB)', contentType: 'SVOD'},
    {value: 'top-region-movies', label: 'Top 10 Movies by Country', contentType: 'SVOD'},
    {value: 'top-region-series', label: 'Top 10 TV Series by Country', contentType: 'SERIES'},
    {value: 'custom-siber-1', label: 'SIBER Curated Movies 1', contentType: 'SVOD'},
    {value: 'custom-siber-2', label: 'SIBER Curated Movies 2', contentType: 'SVOD'}
];

export const MainTypeOptions = [
    {value: 'category', label: 'Category'},
    {value: 'continue_watching', label: 'Continue Watching'},
    {value: 'continue_watching_movies', label: 'Continue Watching - Movies'},
    {value: 'continue_watching_series', label: 'Continue Watching - Series'},
    {value: 'recently_watched', label: 'Recently Watched'},
    {value: 'recently_watched_movies', label: 'Recently Watched - Movies'},
    {value: 'recently_watched_series', label: 'Recently Watched - Series'},
    {value: 'watchlist_movies', label: 'Watchlist - VOD', contentType: 'SVOD'},
    {value: 'watchlist_series', label: 'Watchlist - TV Series', contentType: 'SERIES'},
    {value: 'watchlist_live_matches', label: 'Watchlist - Live Matches', contentType: 'LIVE_SPORTS'},
    {value: 'watchlist_live_events', label: 'Watchlist - Live Events', contentType: 'LIVE_EVENTS'},
    {value: 'new_releases', label: 'New Releases'},
    {value: 'most_popular', label: 'Most Popular'},
    {value: 'because_you_watched', label: 'Because you have watched'},
    ...RecommendationTypeOptions,
    {value: 'watching_now', label: 'Being watched now'},
    {value: 'feature', label: 'Featured - Section'}
];

export function getMenuItemContentType(value) {
    const option = MainTypeOptions.find(item => item.value === value);
    return option && option.contentType ? option.contentType : null;
}

export function getMenuItemTypeState(option) {
    const value = option === null ? null : option.value;
    const contentType = getMenuItemContentType(value);
    return {
        menu_item_type: value,
        ...(contentType ? {
            menu_item_content_type: contentType,
            // Watchlists and recommendations resolve their contents through their APIs.
            menu_item_category_id: null,
            menu_item_sub_type: null
        } : {})
    };
}
